package com.milta.core.localization.translations.en

import com.milta.core.localization.AdminPromptsStrings

internal val AdminPrompts = AdminPromptsStrings(
    loading = "Loading…",
    errorNoConnection = "Unable to reach the server — check your connection.",
    errorGeneric = "Something went wrong. Please try again later.",
    contractLockedNotice = "🔒 The output contract (JSON format) stays locked — it's appended automatically server-side after the edited text, so production extraction never breaks.",
    notModifiedLabel = "Default value — never modified",
    modifiedOnPrefix = "Modified on",
    resetToDefaultAction = "↺ Reset to default values",
    editableBodyLabel = "✏️ Editable body — business rules",
    markdownBoldSnippet = "**bold text**",
    markdownItalicSnippet = "*italic text*",
    markdownCodeSnippet = "`code`",
    markdownHeadingSnippet = "## Heading",
    markdownBulletSnippet = "- list item",
    markdownNumberedSnippet = "1. list item",
    markdownQuoteSnippet = "> quote",
    previewToggleEdit = "✏️ Edit",
    previewToggleShow = "👁 Preview",
    contractFooterLabel = "🔒 Output contract — locked, added automatically",
    actionErrorOffline = "Failed — check your connection.",
    actionErrorGeneric = "Failed to save, please try again.",
    unsavedChangesNotice = "● Unsaved changes",
    savingAction = "Saving…",
    saveAction = "Save changes",
)
